import React from "react";
import { cva } from "class-variance-authority";
import { Loader2 } from "lucide-react";
import { cn } from "../../lib/cn";

const spinnerStyles = cva("animate-spin", {
  variants: {
    size: {
      sm: "h-4 w-4",
      md: "h-6 w-6",
      lg: "h-8 w-8",
    },
  },
  defaultVariants: {
    size: "md",
  },
});

/**
 * Spinner
 * @param {"sm"|"md"|"lg"} [size="md"]
 * @param {string} [color="text-primary-900 dark:text-primary-300"]
 * @param {string} [label="Loading"]
 * @param {string} [className]
 */
export function Spinner({ size = "md", color = "text-primary-900 dark:text-primary-300", label = "Loading", className, ...props }) {
  return (
    <span role="status" aria-label={label}>
      <Loader2 className={cn(spinnerStyles({ size }), color, className)} aria-hidden="true" {...props} />
      <span className="sr-only">{label}</span>
    </span>
  );
}
